import { MDCLinearProgress } from '@material/linear-progress'

export class LinearProgressIndicator {
    constructor() {
        this.initialize;
    }

    initialize = () => {
        const linearProgress = new MDCLinearProgress(document.querySelector('.mdc-linear-progress'));
    }
}